module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.picList.length > 0) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('van-swipe', {
    attrs: {
      "indicator-color": "#F7B500",
      "duration": 300
    }
  }, _vm._l((_vm.picList), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('img', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:item.id }}"
      }],
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "zhou-wrap"
  }, [_c('div', [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'PageGuojijiaoliuDetail',
        query: {
          cate_id: 125
        }
      }),
      expression: "{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 125 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/8a6f98da6f5338e4f491af60367fefc0.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'PageGuojijiaoliuDetail',
        query: {
          cate_id: 124
        }
      }),
      expression: "{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 124 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/db300ab269a7303024c46bc295d51643.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'PageGuojijiaoliuDetail',
        query: {
          cate_id: 128
        }
      }),
      expression: "{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 128 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/3b8b466099e903ab6d8c63530b1647be.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'PageGuojijiaoliuDetail',
        query: {
          cate_id: 126
        }
      }),
      expression: "{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 126 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/3f10a8bfe8038a47bab67604d0cef20f.png"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'PageGuojijiaoliuDetail',
        query: {
          cate_id: 127
        }
      }),
      expression: "{ name: 'PageGuojijiaoliuDetail', query: { cate_id: 127 } }"
    }],
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230424/user-0/20230424/fa547d1f8da0525ee3658dd49183374c.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jingwai-title"
  }, [_c('p', {
    staticClass: "icon1"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("活动新闻")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("News")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: 57
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:57 }}"
    }],
    staticClass: "more"
  }, [_vm._v("更多 >")])]), _vm._v(" "), _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 668
        }
      }),
      expression: "{name:'NewsDetail',query:{id:668 }}"
    }],
    attrs: {
      "title": "·参与资格",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 669
        }
      }),
      expression: "{name:'NewsDetail',query:{id:669 }}"
    }],
    attrs: {
      "title": "·参与流程",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 670
        }
      }),
      expression: "{name:'NewsDetail',query:{id:670 }}"
    }],
    attrs: {
      "title": "·出访提示",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 671
        }
      }),
      expression: "{name:'NewsDetail',query:{id:671 }}"
    }],
    attrs: {
      "title": "·技术支持",
      "is-link": ""
    }
  })], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingwai-title"
  }, [_c('p', {
    staticClass: "icon1"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("境外活动")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jingwai-title"
  }, [_c('p', {
    staticClass: "icon1"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('p', {
    staticClass: "more"
  }, [_vm._v("更多 >")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d005518a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Guojijiaoliu.vue
// module id = 2599
// module chunks = 0